import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';
import { Border, Colors, Font, Spacing, ZIndex } from 'web-common/src/shared/styles';
import { TooltipColors } from './types';

type InlineColorStylesProps = {
  tooltipColor?: TooltipColors;
  showArrow?: boolean;
};

export const getArrowInlineColorStyles = (props: InlineColorStylesProps) => {
  const { tooltipColor, showArrow } = props;
  return match({ tooltipColor, showArrow })
    .with({ showArrow: false }, () => ({
      arrowColor: Colors.BLACK,
      arrowStyle: { opacity: 0 },
    }))
    .with({ tooltipColor: TooltipColors.RED }, () => ({
      arrowColor: Colors.RADISH,
      arrowStyle: { opacity: 1 },
    }))
    .with({ tooltipColor: TooltipColors.WHITE }, () => ({
      arrowColor: Colors.WHITE,
      arrowStyle: { opacity: 1 },
    }))
    .otherwise(() => ({
      arrowColor: Colors.BLACK,
      arrowStyle: { opacity: 0.85 },
    }));
};
export const getTooltipColorStyles = (tooltipColor?: TooltipColors) =>
  match(tooltipColor)
    .with(
      TooltipColors.EGGPLANT,
      () => css`
        background-color: ${Colors.EGGPLANT};
        color: ${Colors.WHITE};
      `
    )
    .with(
      TooltipColors.RED,
      () => css`
        background-color: ${Colors.RADISH};
        color: ${Colors.WHITE};
      `
    )
    .with(
      TooltipColors.WHITE,
      () => css`
        background-color: ${Colors.WHITE};
        color: ${Colors.GRAY_DARK_30};
      `
    )
    .otherwise(
      () => css`
        background-color: rgba(0, 0, 0, 0.85);
        color: ${Colors.WHITE};
      `
    );

export const InfoIcon = styled.i.attrs(() => ({
  className: 'fa-solid fa-info-circle',
}))``;

export const ContentContainer = styled.div<{
  showShadow?: boolean;
  tooltipColor?: TooltipColors;
  tooltipMaxWidth?: string;
}>`
  border-radius: ${Border.Radius.M};
  font-family: ${Font.Family.SANS};
  font-size: ${Font.Size.XS};
  max-width: ${({ tooltipMaxWidth }) => tooltipMaxWidth || '300px'};
  margin-bottom: 0;
  padding: ${Spacing.HALF} ${Spacing.THREE_QUARTERS};
  z-index: ${ZIndex.Tooltip};
  ${({ tooltipColor }) => getTooltipColorStyles(tooltipColor)}
  ${ifProp(
    'showShadow',
    css`
      box-shadow: 0 ${Spacing.EIGHTH} ${Spacing.QUARTER} rgba(0, 0, 0, 0.25);
    `
  )}
`;

export const TriggerContainer = styled.div`
  display: inline-block;
  cursor: default;
`;
